import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { MSAL_CONFIG } from "./authConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const msalInstance = new PublicClientApplication(MSAL_CONFIG);

root.render(
  <React.StrictMode>
    <React.Suspense fallback={<div>Loading...</div>}>
      <MsalProvider instance={msalInstance}>
          <App />
      </MsalProvider>
    </React.Suspense>
  </React.StrictMode>
);

reportWebVitals();
